export default __webpack_public_path__ + "static/media/exclamation-blue.929260db.svg";